(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/prescript.js');

'use strict';

svs.matchen.collections = svs.matchen.collections || {};
svs.matchen.controllers = svs.matchen.controllers || {};
svs.matchen.models = svs.matchen.models || {};
svs.matchen.views = {};
svs.matchen.app = svs.matchen.app || {};
svs.matchen.app.config = svs.matchen.app.config || {};

var isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ?
                      svs.core.config.data.svsconfig.isSelfService :
                      false;

if (isSelfService) {
  svs.components.selfserviceCart.getCartInstance().setGameCallback(function() {
    var model = svs.utils.ns.isNamespace('svs.matchen.views.drawDetail.model') ? svs.matchen.views.drawDetail.model : null;
    if (model) {
      var isPayable = model.isValid();
      var isAnySet = model.hasSelections();
      if (isPayable) {
        return svs.components.selfserviceCart.constants.GAMECALLBACK_HASCOMPLETEGAME;
      } else if (isAnySet) {
        return svs.components.selfserviceCart.constants.GAMECALLBACK_HASINCOMPLETEGAME;
      }
    }
    return svs.components.selfserviceCart.constants.GAMECALLBACK_NOGAME;
  });
}


 })(window);